import { render, staticRenderFns } from "./LibraryView.vue?vue&type=template&id=4f541edc"
import script from "./LibraryView.vue?vue&type=script&lang=js"
export * from "./LibraryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports